import {Editor, JSONContent} from '@tiptap/react';
import {MessageThread, Message, MessageAttachment} from '@/api/dto/message';
import {Wrapper, MessageEditorWrapper} from '@common/messages/Chat.styles';
import MessageEditor from '@common/messages/MessageEditor';
import Conversation from '@common/messages/Conversation';
import Loading from '@common/Loading';

type Props = {
  thread?: MessageThread;
  lastSeenMessage?: Message;
  isLoading?: boolean;
  isDisabled?: boolean;
  dischargeAttachmentsOnly?: boolean;
  onUpdate?(editor: Editor): void;
  onMessage(content: JSONContent, attachments: File[]): void;
  onAttachmentDelete(message: Message, attachment: MessageAttachment): void;
}

export default function Chat(props: Props) {
  return (
    <Wrapper data-testid="chat">
      <MessageEditorWrapper>
        <MessageEditor
          isDisabled={props.isDisabled}
          dischargeAttachmentsOnly={props.dischargeAttachmentsOnly}
          onUpdate={props.onUpdate}
          onSubmit={props.onMessage}
        />
      </MessageEditorWrapper>
      {props.isLoading
        ? <Loading />
        : <Conversation
          messages={props.thread?.messages ?? []}
          lastSeenMessage={props.lastSeenMessage}
          onAttachmentDelete={props.onAttachmentDelete}
        />}
    </Wrapper>
  );
}
